/**
 * Created by christiancueni on 29/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { BehaviorSubject } from 'rxjs';
import { Injectable, NgZone } from '@angular/core';

const NAV_MIN_WIDTH = 992;

@Injectable()
export class MediaQueryService {

    public navMinWidth = NAV_MIN_WIDTH;

    private observables = {};

    constructor(private zone: NgZone) {
    }

    public minWidth(pixels: number): BehaviorSubject<boolean> {
        let query = `(min-width: ${pixels}px)`;

        if (this.observables[ query ]) {
            return this.observables[ query ];
        } else {
            let initialValue = window.innerWidth > pixels;
            let subject$ = new BehaviorSubject(initialValue);

            let mediaQuery = window.matchMedia(query);
            mediaQuery.addListener((mediaQueryList) => {
                this.zone.run(() => {

                    if (mediaQueryList.matches) {
                        subject$.next(true);
                    } else {
                        subject$.next(false);
                    }
                });
            });

            this.observables[ query ] = subject$;
            return subject$;
        }
    }
}
